import React from 'react';
import styled from '@emotion/styled';

import playArrow from '../../assets/playArrow.svg';

const Div = styled.button`
  background: rgba(0, 0, 0, 0.5);
  border: none;
  outline: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  z-index: 1;
`;

const Img = styled.img`
  height: 48px;
  width: 48px;
  padding: 12px;
`;

export interface QuoteCardProps {
  quote?: string;
  imageUrl: string;
  isCarousel?: boolean;
  isFullScreen?: boolean;
}

export const RecommenderPlayIcon = () => {
  return (
    <Div>
      <Img src={playArrow} />
    </Div>
  );
};
